import { css } from "@emotion/react";
import colors from "assets/css/colors";
import { SORT_DIRECTION } from "constants/common";

const arrowBaseCss = css`
  gap: 2px;
  &:before,
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }
  &:before {
    border-bottom: 5px solid ${colors.grey};
  }
  &:after {
    border-top: 5px solid ${colors.grey};
  }
`;

const arrowDownCss = [
  arrowBaseCss,
  css`
    &:before {
      border-bottom-color: ${colors.mainBlack};
    }
  `,
];

const arrowUpCss = [
  arrowBaseCss,
  css`
    &:after {
      border-top-color: ${colors.mainBlack};
    }
  `,
];

export default function arrowCss({ isSorted, sortDir }) {
  if (isSorted && sortDir === SORT_DIRECTION[0]) return arrowDownCss;

  if (isSorted && sortDir === SORT_DIRECTION[1]) return arrowUpCss;

  return arrowBaseCss;
}
